import React from 'react';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';

import './OriginalsBanner.scss';

import { INetwork } from '../../utils/models';

export interface IOriginalsBannerProps {
  network: INetwork;
  mobileImage: IGatsbyImageData;
  desktopImage: IGatsbyImageData;
}

const OriginalsBanner = ({
  network: { networkImgUrl, description },
  mobileImage,
  desktopImage,
}: IOriginalsBannerProps) => {
  return (
    <div className="originals-banner__wrapper">
      <div className="originals-banner">
        <div className="originals-banner__img-wrapper">
          <GatsbyImage
            className="originals-banner__img-desktop"
            image={getImage(desktopImage) as IGatsbyImageData}
            alt=""
          />
          <GatsbyImage
            className="originals-banner__img-mobile"
            image={getImage(mobileImage) as IGatsbyImageData}
            alt=""
          />
        </div>
        <div className="originals-banner__description-wrapper">
          <img src={`${networkImgUrl}&sourceType=colorHybrid`} />
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default OriginalsBanner;
